export enum playerQuizLocation {
    Team = 'team',
    Unattached = 'unattached',
    UnattachedAndUnregistered = 'unattachedAndUnregistered'
  }